import { useStoryblokApi, useStoryblokBridge } from "@storyblok/vue";
import { onMounted, reactive, useAsyncData, useState } from "#imports";
export const useAsyncStoryblok = async (url, apiOptions = {}, bridgeOptions = {}) => {
  const storyblokApiInstance = useStoryblokApi();
  const uniqueKey = `${JSON.stringify(apiOptions)}${url}`;
  const story = useState(`${uniqueKey}-state`);
  const error = useState(`${uniqueKey}-error`);
  onMounted(() => {
    if (story.value && story.value.id) {
      useStoryblokBridge(
        story.value.id,
        (evStory) => story.value = evStory,
        bridgeOptions
      );
    }
  });
  if (!story.value) {
    try {
      const { data } = await useAsyncData(uniqueKey, () => {
        return storyblokApiInstance.get(
          `cdn/stories/${url}`,
          apiOptions
        );
      });
      if (data) {
        story.value = data.value?.data.story;
        error.value = null;
      }
    } catch (err) {
      if (typeof err === "object" && err !== null && "status" in err && "response" in err) {
        error.value = {
          status: err.status || err.response?.status,
          response: err.message || err.response?.statusText
        };
      } else {
        error.value = {
          status: void 0,
          response: "An unknown error occurred"
        };
      }
    }
  }
  return reactive({
    get value() {
      return story.value;
    },
    set value(newValue) {
      story.value = newValue;
    },
    get status() {
      return error.value?.status;
    },
    get response() {
      return error.value?.response;
    }
  });
};
